import { render } from "./CandlesComponent.vue?vue&type=template&id=eba1174c&scoped=true"
import script from "./CandlesComponent.vue?vue&type=script&lang=js"
export * from "./CandlesComponent.vue?vue&type=script&lang=js"

import "./CandlesComponent.vue?vue&type=style&index=0&id=eba1174c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Shavin\\Documents\\apps\\10-candles\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eba1174c"]])

export default __exports__